import { useContext } from 'react';

import { DefaultValuesContextType, AuthContext } from './AuthContext';

export const useAuth = (): DefaultValuesContextType => {
  const { loading, isAuthenticated, user, refetch } =
    useContext(AuthContext);

  return {
    loading,
    isAuthenticated,
    user,
    refetch,
  };
};
